<div class="date">
	<div class="input">
		<input #date (input)="onInputDate($event.target.value)" (click)="$event.preventDefault();" type="date" required [disabled]="disableSelectDate">
		<ng-container *ngIf="!hideClearButton">
			<button i18n [disabled]="disableSelectDate" type="button" appSkin="simple-cancel" (click)="clear()">Очистить</button>
		</ng-container>
	</div>
	<div class="date-pickers">
		<app-date-picker [disableSelectDate]="disableSelectDate" [value]="value" [date]="value" (valueChange)="onValueChange($event)" [dayLimit]="dayLimit" [isDateLimit]="isDateLimit">
			<!-- (keyup.enter)="onEnter($event)" -->
		</app-date-picker>
	</div>
</div>

<ng-container *ngIf="!hideTime">
	<app-time-picker *ngIf="withTime" [value]="value" (appEmitTime)="emitTime($event)"></app-time-picker>
</ng-container>

<template #messageValue>
	<dl>
		<dt>maxDateError</dt>
		<dd i18n>Дата не может быть больше, чем </dd>
		<dt>minDateError</dt>
		<dd i18n>Дата не может быть меньше, чем </dd>
	</dl>
</template>
